// Chef portrait helper. Every contributor card, byline, author bio and
// press mention deserves a real headshot, never grey initials. When a
// contributor has an uploaded photo we use it as-is; when they do not,
// this helper picks a portrait from a curated pool and hashes the
// contributor's slug so the same person always gets the same face
// across reloads and pages.
//
// Portraits are sourced from randomuser.me/api/portraits which serves
// AI-composed, gender-labelled JPGs at stable URLs. Using randomuser.me
// (rather than random Unsplash IDs) means we can guarantee gender-name
// alignment: a manual pin to men/N.jpg is guaranteed to render a male
// face, and women/N.jpg a female face.

const MEN = (n) => `https://randomuser.me/api/portraits/men/${n}.jpg`;
const WOMEN = (n) => `https://randomuser.me/api/portraits/women/${n}.jpg`;

// Fallback pool. Mixed genders alternately so a hash-based random pick
// stays balanced. Only used when a contributor slug is not in
// MANUAL_PINS below.
const POOL = [
  MEN(67), WOMEN(44), MEN(45), WOMEN(68),
  MEN(32), WOMEN(32), MEN(85), WOMEN(85),
];

// Manual pins for the three launch contributors. The URL path itself
// encodes the gender: men/... is guaranteed male, women/... is
// guaranteed female. This closes the "James (male name) shown with a
// woman's photo" bug reported on 2026-02-19.
const MANUAL_PINS = {
  "antoine-girard": MEN(67),    // Antoine, executive chef, mid-40s vibe
  "marisol-vega":   WOMEN(44),  // Marisol, head chef, late-30s vibe
  "james-ashworth": MEN(45),    // James, head of operations, mid-40s vibe
};

function hashString(s) {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (h * 31 + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

// Returns a headshot URL for a contributor. Argument shape is loose so
// this can accept the full API contributor object OR just a name/slug
// pair used inside a byline row where we only have the join fields.
export function chefPortraitFor(contributor) {
  if (!contributor) return POOL[0];
  const slug = (contributor.slug || "").toLowerCase();
  if (slug && MANUAL_PINS[slug]) return MANUAL_PINS[slug];
  const seed = slug || contributor.name || contributor.id || "chef";
  return POOL[hashString(seed) % POOL.length];
}
